import { lang } from '@umu/ukit-lang';
import { getFontSizeSwitchList, updateFontSize } from '../../../@utils/umuUtil';
import _get from 'lodash/get';

import React, { useState, useEffect, useCallback } from 'react';
import './menuItemLangSwitch.scss';
import { $location } from '@umu/umu-dom';
import { $window } from '@umu/umu-dom';

import { components } from 'common';
const { If, Portal } = components;

import IUserMenuController from '../userMenuController';
import ConfigurableHeader from '../../@configurableHeader/configurableHeader';
import CoverPage from '../../@coverPage/coverPage';

function useSystemConfig() {
    const config = _get($window, 'pageData.config', {
        fontSize: 'small',
    });
    return config;
}

const fontSizeSwitchList = getFontSizeSwitchList();

interface ILangSwitchProps {
    controller: IUserMenuController;
}

export default function FontSizeSwitch(props: ILangSwitchProps) {
    const config = useSystemConfig();
    const [isShow, setIsShow] = useState(false);
    const [selectedFontSize, setSelectFontSize] = useState(
        fontSizeSwitchList.find((item) => item.key === config.lang) || fontSizeSwitchList[0],
    );
    const closePanel = useCallback(_closePanel, [isShow]);
    const openPanel = useCallback(_openPanel, [isShow]);
    const controller = props.controller;

    useEffect(() => {
        setSelectFontSize(fontSizeSwitchList.find((item) => item.key === config.node_html_font_size) || fontSizeSwitchList[0]);
    }, [config]);

    function _openPanel() {
        setIsShow(true);
        if (controller) {
            controller.hide();
        }
    }

    function _closePanel() {
        setIsShow(false);
        if (controller) {
            controller.show();
        }
    }

    function save() {
        updateFontSize(selectedFontSize).then(() => {
            $location.reload();
        });
    }

    function getHeaderConfig() {
        const headerConfig = {
            leftProp: {
                label: lang('取消'),
                clsName: 'btn-text',
                callback: closePanel,
            },
            centerProp: {
                label: lang('字号设置'),
                clsName: 'btn-text',
            },
            rightProp: {
                label: lang('完成'),
                clsName: 'btn-text',
                callback: save,
            },
        };
        return headerConfig;
    }

    function renderFontSizeList() {
        return fontSizeSwitchList.map((fontSizeItem, index) => {
            return (
                <li key={index} className="lang-item" onClick={() => setSelectFontSize(fontSizeItem)}>
                    <If condition={fontSizeItem === selectedFontSize}>
                        <span className="is-checked"></span>
                    </If>
                    <span className="lable">{fontSizeItem.value}</span>
                </li>
            );
        });
    }

    function renderFontSizePanel() {
        if (!isShow) {
            return null;
        }
        return (
            <Portal preventBodyScroll={true}>
                <CoverPage clsName="lang-switch-panel-cover-page">
                    <div className="lang-switch-panel">
                        <div className="panel-shadow"></div>
                        <div className="lang-switch">
                            <div className="lang-header-container">
                                <ConfigurableHeader clsName="lang-switch-header" config={getHeaderConfig()} />
                            </div>
                            <div className="lang-list">
                                <ul>{renderFontSizeList()}</ul>
                            </div>
                        </div>
                    </div>
                </CoverPage>
            </Portal>
        );
    }

    function render() {
        return (
            <div className="lang-switch-menu-item">
                <div onClick={openPanel}>
                    <span className="item-label">{lang('字号设置')}</span>
                    <span className="item-value">
                        <span>{selectedFontSize.value}</span>
                        <i className="icon icon-arrow arrow1 gray right size-xs" />
                    </span>
                </div>
                {renderFontSizePanel()}
            </div>
        );
    }

    return render();
}
